var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_vm.componentName, {
    tag: "component",
    attrs: { title: _vm.title, item: _vm.item },
    on: {
      close: function ($event) {
        return _vm.close()
      },
      confirm: function ($event) {
        return _vm.onConfirm()
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }